import { useEffect } from "react";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export const useDisableWindowScroll = disableScroll => {
  useEffect(() => {
    const cls = legacyClassNames("disable-scroll");
    if (!cls) return;
    if (disableScroll) {
      document.body.classList.add(cls);
      let counter =
        parseInt(document.body.dataset.disableScrollCounter, 10) || 1;
      counter += 1;
      document.body.dataset.disableScrollCounter = counter.toString();
    } else {
      let counter =
        parseInt(document.body.dataset.disableScrollCounter, 10) || 1;
      counter = counter - 1;
      if (counter <= 0) {
        document.body.classList.remove(cls);
      }
      document.body.dataset.disableScrollCounter = Math.max(
        counter,
        0,
      ).toString();
    }
    return () => {
      document.body.classList.remove(cls);
    };
  }, [disableScroll]);
};
